import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IonIcon } from '@ionic/react';
import { alertCircleOutline, saveOutline } from 'ionicons/icons';
import './style.css';
export const TabNotification = (tabText, hasError, isUnsaved) => {
    if (hasError && isUnsaved) {
        return (_jsxs("div", { className: `vn-tab-error-title`, children: [tabText, _jsx(IonIcon, { icon: alertCircleOutline, className: 'vn-tab-error-icon' }), _jsx(IonIcon, { icon: saveOutline, className: 'vn-tab-unsaved-icon' })] }));
    }
    else if (hasError) {
        return (_jsxs("div", { className: `vn-tab-error-title`, children: [tabText, _jsx(IonIcon, { icon: alertCircleOutline, className: 'vn-tab-error-icon' })] }));
    }
    else if (isUnsaved) {
        return (_jsxs("div", { className: `vn-tab-title-div`, children: [tabText, _jsx(IonIcon, { icon: saveOutline, className: 'vn-tab-unsaved-icon' })] }));
    }
    else {
        return (_jsx("div", { className: `vn-tab-title-div`, children: tabText }));
    }
};
